import { List, Datagrid, TextField, SimpleList, ShowButton, ReferenceField, TextInput } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { careerCenterRequests } from "api/careerCenterApi";
import { MobileListRow } from "features/MobileListRow";

const ListAlumni = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <List
      exporter={false}
      filters={[
        <TextInput
          source="FirstName"
          label="Име"
          alwaysOn
        />,
        <TextInput
          source="LastName"
          label="Фамилия"
          alwaysOn
        />,
      ]}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              style={{ marginRight: 16 }}
              fields={[{ label: "Година на семестриално завършване", value: record.semesterCompletionYear }]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  { label: "Име", value: record.firstName },
                  { label: "Презиме", value: record.secondName },
                  { label: "Фамилия", value: record.lastName },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: (
                      <ReferenceField
                        label="Статус"
                        source="status"
                        reference={careerCenterRequests.getStatusesSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => <ShowButton label="" />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="secondName"
            label="Презиме"
            sortable={false}
          />
          <TextField
            source="lastName"
            label="Фамилия"
            sortable={false}
          />
          <TextField
            sx={{ display: "block", margin: "0 auto", width: "fit-content" }}
            source="semesterCompletionYear"
            label="Година на семестриално завършване"
            sortable={false}
          />
          <ReferenceField
            label="Статус"
            source="status"
            reference={careerCenterRequests.getStatusesSelect()}
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListAlumni;
